import React, { Component } from 'react';
import { connect } from 'react-redux';
import { findUser } from 'actions/users';
import { getUser } from 'reducers';

/**
 * Component that takes user id and displays user data
 * @param {String | Number} userId - user id prop
 * @param {String} type - type of format
 * @param {Function} formatUser - function that provides user object and return formatted user data.
 */
class UserInfo extends Component {
  componentDidMount() {
    const { userId } = this.props;
    this.findUser(userId);
  }

  componentDidUpdate(oldProps) {
    if (this.props.userId !== oldProps.userId) {
      this.findUser(this.props.userId);
    }
  }

  findUser = () => {
    const { user, userId, findUser } = this.props;
    if (!user && userId) {
      findUser(userId);
    }
  };

  formatUserData = () => {
    const { user, type, formatUser } = this.props;
    if (!user) return '';

    if (typeof formatUser === 'function') {
      return formatUser(user);
    }

    switch (type) {
      case 'nameIdRole':
        return `${user.first_name} ${user.last_name} - ${user.id} - ${user.acl_group_name}`;

      default:
        return `${user.id} ${user.first_name} ${user.last_name}`;
    }
  };

  render() {
    return <span>{this.formatUserData()}</span>;
  }
}

const mapStateToProps = (state, ownProps) => {
  const user = ownProps.userId ? getUser(state, ownProps.userId) : undefined;
  return {
    user,
  };
};

const mapDispatchToProps = {
  findUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserInfo);
